<template>
  <el-button-group>
    <el-button
      size="small"
      :disabled="pageNo === 1"
      type="default"
      icon="el-icon-arrow-left"
      @click="$emit('on-change', pageNo - 1)"
    >
      上一页
    </el-button>
    <el-button
      size="small"
      type="default"
      :disabled="isEnd"
      icon="el-icon-arrow-right"
      @click="$emit('on-change', pageNo + 1)"
    >
      下一页
    </el-button>
  </el-button-group>
</template>

<script>
/**
 * @file 只有上下翻页的分页器
 * <skinny-pagination pageNo='1' :is-end='pageNo * pageSize >= totalCount' @on-change="onChange($page)" />
 * */

export default {
  name: 'skinny-pagination',
  props: {
    pageNo: {
      type: Number,
      default: 1
    },
    isEnd: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped></style>
